<template>
	<div class="content">
		<h3>出库单统计</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="80px">
				<el-form-item label="时间类型">
					<el-select v-model="form.timestate" placeholder="请选择" >
						<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="起始日期">
					<el-date-picker
						v-model="form.starttime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="终止日期">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item label="出库单号">
					<el-input v-model="form.odd" placeholder="请输入单号" clearble></el-input>
				</el-form-item>

                <el-form-item label="产品">
					<el-input v-model="form.product" placeholder="请选择产品" :value="form.productnum" @focus="productfocus"></el-input>
				</el-form-item>

                <el-form-item label="出库库房">
					<el-select v-model="form.outstore" @change="selChange" @focus="getStore" placeholder="请选择" >
						<el-option
						v-for="item in warehouse"
						:key="item.StoreCode"
						:label="item.StoreName"
						:value="item.StoreCode">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="出库类型">
					<el-select v-model="form.outstate" placeholder="请选择" >
						<el-option
						v-for="item in outstock"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="数码">
					<el-input v-model="form.num" placeholder="请输入数值" clearble></el-input>
				</el-form-item>

                <el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked1">只看单据计划量与处理成功数量不一致的单据</el-checkbox>
				</el-form-item>
                 <el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked2">显示已删除、已覆盖的单据</el-checkbox>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary" @click="selectQry">查 询</el-button>
                <el-button type="warning">重 置</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border >
				<el-table-column align="center" prop="Order" label="出库单号"></el-table-column>
				<el-table-column align="center" prop="ProductCode" label="产品编号"></el-table-column>
				<el-table-column align="center" prop="ProductCodeName" label="产品名称"></el-table-column>
				<el-table-column align="center" prop="SpecName" label="规格名称"></el-table-column>
				<el-table-column align="center" prop="AddTime" label="创建时间"></el-table-column>
				<el-table-column align="center" prop="OutTime" label="更新时间"></el-table-column>
				<el-table-column align="center" prop="ShipperName" label="发货单位"></el-table-column>
                <el-table-column align="center" prop="ReceiverName" label="收货单位"></el-table-column>
                <el-table-column align="center" prop="OperUser" label="操作员"></el-table-column>
				<el-table-column align="center" label="查看异常" >
					<template slot-scope="scope">
						<el-button type="text" @click="ShowExecption(scope)">查看</el-button>
					</template>
				</el-table-column>
                <el-table-column align="center" prop="Hnum_cs" label="托数量"></el-table-column>
                <el-table-column align="center" prop="Hnum_sb" label="箱数量"></el-table-column>
                <el-table-column align="center" prop="Hnum_pc" label="盒数量"></el-table-column>
                <el-table-column align="center" prop="TotalNums" label="合计"></el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentPageChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
		<el-dialog
			title="选择产品"
			:visible.sync="dialogVisible"
			width="600px">
			<el-table :data="gridData" highlight-current-row
    @row-click="handleCurrentChange">
				<el-table-column align="center" width="80" property="DataId" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="Productcode" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="Productname" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="Shortname" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="Norms" label="包装比例"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="异常码详情"
			:visible.sync="dialogCodeVisible"
			width="600px">
			<el-table :data="codeExecptionData" highlight-current-row
    @row-click="handleCurrentChange">
				<el-table-column align="center" width="120" property="DataId" label="异常单号"></el-table-column>
				<el-table-column align="center" width="120" property="Productcode" label="异常数码"></el-table-column>
				<el-table-column align="center" width="120" property="Productname" label="异常描述"></el-table-column>
				<el-table-column align="center" width="120" property="Shortname" label="异常时间"></el-table-column>
				<el-table-column align="center" width="120" property="Norms" label="操作员"></el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentCodePageChange"
			layout="total,prev, pager, next,jumper"
			:total="pagecodeNum"
			:page-size="10">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data(){
		return {
			dialogVisible: false,
			dialogCodeVisible:false,
			form: {
				timestate: '', //时间类型
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //出库单号
				product: '',   //产品名称
				productnum:'', //产品编号
				outstore:'',   //出库库房
				outstate:'',   //出库类型
				num:'',        //数码
				checked1: false,  //单据类型选择
				checked2: false,  //单据类型选择
			},
			
			options: [{
				value: 1,
				label: '创建时间'
				}, {
				value: 2,
				label: '更新时间'
			}],
            warehouse: [],
            outstock: [{
				value: 1,
				label: '销售出库'
			},{
				value: 2,
				label: '调拨出库'
			}],
            

			gridData: [],
			current:null,
			tableData: [],
			pageIndex:1,
			pageNum:0,
			//异常码数据
			codeExecptionData:[],
			pagecodeIndex:1,
			pagecodeNum:0,
		}
	},
	methods:{
		selChange(val){
			
			
		},
		confirm(){
			this.form.product = this.current.Shortname + this.current.Productname +this.current.Norms;
			this.form.productnum = this.current.Productcode;
			this.dialogVisible = false
		},
		handleCurrentChange(data){
			this.current = data
		},

		productfocus(){
			//	请求产品数据
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params:{
					action:"query",
					cid:user.QyNum
				}
			})
			.then(res=>{
				if(res.Code==0){
					this.gridData=res.DataList;
					this.dialogVisible = true
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					})
				}
			})
		},

		getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
					console.log(res);
					if(res.Code==0){
						this.warehouse=res.DataList;
					}else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}      
			})
		},

		handleCurrentPageChange(index){
			this.pageIndex=index;
			this.selectQry()
		},

		selectQry(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			console.log(this.form)
			this.$axios({
				method: 'post',
				url:'/FW/OutListSTA.ashx',
				params:{
					action:"OutListSTA",
					qry: this.form,
					cid:user.QyNum,
					pageIndex:this.pageIndex
				}
			})
			.then(res=>{
				if(res.Code==0){
					this.tableData=res.Data.DataList
					this.pageNum=res.Data.Total
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}     
			})
		},
		//异常码显示
		ShowExecption(scope){
			this.selectCodeQry()
		},
		handleCurrentCodePageChange(){
			this.pagecodeIndex=index;
			this.selectCodeQry()
		},
		selectCodeQry(){
			this.dialogCodeVisible=true;
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
.el-checkbox{
    line-height: 19px;
}
</style>


// WEBPACK FOOTER //
// src/pages/outListQryStatistics.vue